import React from 'react';
import { SearchIcon, Share2Icon } from 'lucide-react';
import type { ShowFilter } from '../types/show';
interface ChecklistToolbarProps {
  seenCount: number;
  wantCount: number;
  total: number;
  filter: ShowFilter;
  onFilterChange: (filter: ShowFilter) => void;
  query: string;
  onQueryChange: (query: string) => void;
  onShare: () => void;
}
export function ChecklistToolbar({
  seenCount,
  wantCount,
  total,
  filter,
  onFilterChange,
  query,
  onQueryChange,
  onShare
}: ChecklistToolbarProps) {
  const filters: {
    id: ShowFilter;
    label: string;
    count: number;
  }[] = [{
    id: 'all',
    label: 'All',
    count: total
  }, {
    id: 'seen',
    label: 'Seen',
    count: seenCount
  }, {
    id: 'want',
    label: 'Want to see',
    count: wantCount
  }, {
    id: 'unmarked',
    label: 'Unmarked',
    count: total - seenCount - wantCount
  }];
  return <div className="sticky top-0 z-20 -mx-5 border-b border-rule bg-paper px-5 py-3 md:-mx-8 md:px-8" data-id="element-19" data-mp="k7ibtsvxwck4">
      <div className="h-1 w-full overflow-hidden bg-rule" aria-hidden="true" data-id="element-20" data-mp="p1misc57gkl7">
        <div className="h-full bg-ink transition-[width] duration-300 ease-out" style={{
        width: `${seenCount / total * 100}%`
      }} data-id="element-21" data-mp="17qusdq6orgmn" />
      </div>

      <div className="mt-3 flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between" data-id="element-22" data-mp="1giwojc9q2ar4">
        <div role="tablist" aria-label="Filter shows" className="flex gap-1 overflow-x-auto font-sans text-sm" data-id="element-23" data-mp="1brofihcb0reh">
          {filters.map(f => {
          const active = filter === f.id;
          return <button key={f.id} type="button" role="tab" aria-selected={active} onClick={() => onFilterChange(f.id)} className={`whitespace-nowrap rounded-full px-3.5 py-1.5 font-semibold transition-colors duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink ${active ? 'bg-ink text-paper' : 'text-muted hover:bg-rule hover:text-ink'}`} data-id="element-24" data-mp="1ljualzxuroxw">
                {f.label}
                <span className={`ml-1.5 tabular-nums ${active ? 'text-paper/70' : 'text-muted'}`} data-id="element-25" data-mp="256sigh85b24l">
                  {f.count}
                </span>
              </button>;
        })}
        </div>

        <div className="flex items-center gap-2" data-id="element-26" data-mp="2f4opoxxypcxf">
          <label className="relative flex-1 lg:w-64 lg:flex-none" data-id="element-27" data-mp="2j5iedtj8avrd">
            <span className="sr-only" data-id="element-28" data-mp="2j58pk99x6un9">Search shows</span>
            <SearchIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted" aria-hidden="true" data-id="element-29" data-mp="2o3tn20xsf080" />
            <input type="search" value={query} onChange={e => onQueryChange(e.target.value)} placeholder="Search the list" className="h-10 w-full rounded-full border border-rule bg-white pl-9 pr-4 font-sans text-sm text-ink placeholder:text-muted focus:border-ink focus:outline-none" data-id="element-30" data-mp="2xu55stm4rdyy" />
          </label>
          <button type="button" onClick={onShare} className="inline-flex h-10 items-center gap-2 whitespace-nowrap rounded-full bg-ink px-4 font-sans text-sm font-semibold text-paper transition-transform duration-150 ease-out active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink focus-visible:ring-offset-2" data-id="element-31" data-mp="r65ue2x186uu">
            <Share2Icon className="h-4 w-4" aria-hidden="true" data-id="element-32" data-mp="1exjmc7r9u0fa" />
            Share my score
          </button>
        </div>
      </div>
    </div>;
}